<script lang="ts">
    import { recordsIntoOutService } from "../services";
    import type { RegisterInOut } from "../Model/RegisterInOut";
    import RegisterModal from "./RegisterModal.svelte";
    import { dateInputFormatter } from '../services/Functions';

    export let third_id: string;
    let registers: RegisterInOut[];

    let editRegister = null;

    editRegister = null;

    $:loadRegisters();

    export async function loadRegisters(): Promise<void> {
        registers = await recordsIntoOutService.getRecordsByThird(third_id);

        registers.sort((a,b) => {
            return a.inRegisterNumber < b.inRegisterNumber ? -1 : 1;
        })
    }

    function registerUpdate(register: RegisterInOut): void {
        let registerAct = registers.find(u => u.id == register.id)

        if (registerAct) {
            registerAct = register
            registers = registers;
        }else{
            registers = [...registers, register];
        }
    }

</script>

<style>

</style>

{#if registers}
    <div class="row mt-3">
        <div class="col-12">
            {#if registers?.length}
            <table class="table">
                <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">Entrada</th>
                            <th scope="col">Fecha Entrada</th>
                            <th scope="col">Salida</th>
                            <th scope='col'>Fecha Salida</th>
                            <th scope="col">Tipo</th>
                        </tr>
                </thead>
                <tbody>
                    {#each registers as register, index }
                        <tr>
                            <th scope="row">{index + 1}</th>
                            <td>
                                {#if register.inRegisterNumber}
                                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                                    <span class="btn btn-link" on:click={() => editRegister = register}>
                                        {register.inRegisterNumber}
                                    </span>
                                {/if}
                            </td>
                            <td>
                                {#if register.inDate}
                                    <!-- {register.inDate} --> 
                                    <span class="pe-2">{dateInputFormatter(register.inDate)}</span>
                                {/if}
                            </td>
                            <td>
                                {#if register.outRegisterNumber}
                                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                                    <span class="btn btn-link" on:click={() => editRegister = register}>
                                        {register.outRegisterNumber}
                                    </span>
                                {/if}
                            </td>
                            <td>
                                {#if register.outDate}
                                    <!-- {register.outDate} -->
                                    <span class="pe-2">{dateInputFormatter(register.outDate)}</span>
                                {/if}
                            </td>
                            <td>
                                {#if register.contentInfo}
                                    {register.contentInfo}
                                {/if}
                            </td>
                        </tr>
                    {/each}
                </tbody>
            </table>
            {:else}
                <div class="text-center pt-5">
                    <hr>
                    <h4>No hay registros para mostrar</h4>
                </div>
            {/if}
        </div>
    </div>
{/if}


<RegisterModal register={editRegister}  on:registerUpdate={() => registerUpdate(editRegister)}/>

